// @src/pre-deployment/src/components/Dashboard.js v1.0
// - Simple dashboard for pre-deployment environment
// - Shows user info and basic functionality
// - Demonstrates successful registration completion

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';

const Dashboard = () => {
  const { user, userProfile, logout } = useAuth();
  const navigate = useNavigate();

  console.group('📊 PRE-DEPLOYMENT DASHBOARD: Component loaded');
  console.log('Current user:', user?.uid);
  console.log('User profile:', userProfile);
  console.groupEnd();

  // Redirect unauthenticated users
  useEffect(() => {
    if (!user) {
      console.log('📊 PRE-DEPLOYMENT DASHBOARD: No authenticated user, redirecting to home');
      navigate('/');
    }
  }, [user, navigate]);

  const handleLogout = async () => {
    console.group('🚪 PRE-DEPLOYMENT DASHBOARD: Logout initiated');
    try {
      await logout();
      console.log('Logout successful');
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
    console.groupEnd();
  };

  if (!user) {
    return (
      <div className="dashboard">
        <div className="dashboard-content">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="dashboard-content">
        <h1>🎉 Registration Complete!</h1>
        <p>Welcome to the pre-deployment environment. Your account has been successfully created and configured.</p>

        <div className="user-info">
          <h3>Account Information</h3>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>User ID:</strong> {user.uid}</p>
          <p><strong>Email Verified:</strong> {user.emailVerified ? '✅ Yes' : '❌ No'}</p>
          <p><strong>Password Set:</strong> {userProfile?.passwordSet ? '✅ Yes' : '❌ No'}</p>
          <p><strong>Registration Date:</strong> {user.metadata.creationTime ? new Date(user.metadata.creationTime).toLocaleDateString() : 'N/A'}</p>
        </div>

        <div className="user-info">
          <h3>Pre-Deployment Status</h3>
          <p>✅ Email verification completed</p>
          <p>✅ Password setup completed</p>
          <p>✅ User profile created</p>
          <p>🚀 Ready for production deployment</p>
        </div>

        <p>This is a testing environment. In production, users would be redirected to the main application after registration.</p>

        <div className="navigation-controls">
          <button className="nav-btn secondary" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
